import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TooltipModule } from 'primeng/tooltip';
import { TagModule } from 'primeng/tag';
import { MessageModule } from 'primeng/message';
import { DividerModule } from 'primeng/divider';
import { InputTextModule } from 'primeng/inputtext';
import { StepsModule } from 'primeng/steps';
import { SpinnerServiceComponent } from '../../shared/spinner-service/spinner-service.component';
import { ToolbarSearchComponent } from '../../shared/toolbarSearch/toolbarSearch.component';
import { DividendosListagemComponent } from './dividendos-listagem/dividendos-listagem.component';
import { DividendosAdicionarComponent } from './dividendos-adicionar/dividendos-adicionar.component';
import { DividendosDetalhesComponent } from './dividendos-detalhes/dividendos-detalhes.component';

@NgModule({
  declarations: [
    DividendosListagemComponent,
    DividendosAdicionarComponent,
    DividendosDetalhesComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    ToolbarModule,
    ButtonModule,
    DialogModule,
    DropdownModule,
    CalendarModule,
    InputNumberModule,
    RadioButtonModule,
    ConfirmDialogModule,
    TooltipModule,
    TagModule,
    MessageModule,
    DividerModule,
    InputTextModule,
    StepsModule,
    SpinnerServiceComponent,
    ToolbarSearchComponent
  ],
  exports: [
    DividendosListagemComponent,
    DividendosAdicionarComponent,
    DividendosDetalhesComponent
  ]
})
export class DividendosModule { }
